import React from "react";
import DataTable from "react-data-table-component";
import { BsFillCaretDownFill } from "react-icons/bs";
import Loader from "./Loader";

const Table = ({
  columns,
  data,
  selectableRows,
  onSelectedRowsChange,
  selectableRowSelected,
  clearSelectedRows = false,
  progressPending = false,
  pagination = true,
  paginationServer = false,
  paginationTotalRows = 0,
  paginationDefaultPage = 1,
  paginationPerPage = 10,
  paginationRowsPerPageOptions = [10, 20, 50, 100],
  paginationResetDefaultPage = false,
  onChangeRowsPerPage,
  onChangePage,
  noDataComponent,
  onSort,
  sortServer = false,
}) => {
  // const getStatusText = (status) => {
  //   return status === "1"
  //     ? "Pending"
  //     : status === "2"
  //     ? "DPA Review"
  //     : status === "3"
  //     ? "Verified"
  //     : status === "4"
  //     ? "Nodal Officer Review"
  //     : status === "5"
  //     ? "Approved"
  //     : status === "6"
  //     ? "Final Approved"
  //     : status === "7"
  //     ? "Rejected"
  //     : status === "8"
  //     ? "Under Process"
  //     : status === "9"
  //     ? "Released"
  //     : "";
  // };

  const caseInsensitiveSort = (rowA, rowB) => {
    const a = String(rowA.status || "").toLowerCase();
    const b = String(rowB.status || "").toLowerCase();
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  const updatedColumns = columns.map((column) =>
    typeof column.name === "string" && column.name.toLowerCase() === "status"
      ? { ...column, sortFunction: caseInsensitiveSort }
      : column
  );

  //  Internally, customStyles will deep merges your customStyles with the default styling.
  const customStyles = {
    table: {
      style: {
        border: "1px solid rgba(0,0,0,.12)",
      },
    },
    headCells: {
      style: {
        padding: "5px",
        "&:not(:last-child)": {
          borderRight: "1px solid rgba(0,0,0,.12)",
        },
      },
    },
    cells: {
      style: {
        padding: "5px",
        wordBreak: "break-word",
        lineHeight: "1.4",
        "&:not(:last-child)": {
          borderRight: "1px solid rgba(0,0,0,.12)",
        },
      },
    },
    rows: {
      style: {
        borderColor: "#000",
        "&:hover": {
          outline: "0 !important",
          borderColor: "rgba(0,0,0,.12) !important",
        },
      },
    },
  };

  const Checkbox = React.forwardRef(({ onClick, ...rest }, ref) => {
    return (
      <>
        <div className="form-check  form-check-inline m-0">
          <input
            {...rest}
            type="checkbox"
            className="form-check-input"
            style={{ width: "20px", height: "20px" }}
            ref={ref}
            onClick={onClick}
          />
        </div>
      </>
    );
  });

  return (
    <DataTable
      columns={updatedColumns}
      data={data}
      sortIcon={<BsFillCaretDownFill />}
      customStyles={customStyles}
      defaultSortFieldId={1}
      progressPending={progressPending}
      progressComponent={<Loader />}
      striped
      highlightOnHover
      pagination={pagination}
      paginationServer={paginationServer}
      paginationTotalRows={paginationTotalRows}
      paginationDefaultPage={paginationDefaultPage}
      paginationPerPage={paginationPerPage}
      paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      paginationResetDefaultPage={paginationResetDefaultPage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      noDataComponent={noDataComponent}
      dense
      selectableRows={selectableRows}
      onSelectedRowsChange={onSelectedRowsChange}
      selectableRowSelected={selectableRowSelected}
      clearSelectedRows={clearSelectedRows}
      selectableRowsComponent={Checkbox}
      onSort={onSort}
      sortServer={sortServer}
    />
  );
};

export default Table;
